import React from "react";
import { useParent } from "../../../context/ParentContext";

export default function ParentDashboard() {
  const { selectedChild } = useParent();
  return (
    <div>
      <h4 style={{ marginBottom: 4, color: "#0f172a" }}>Dashboard</h4>
      <p style={{ color: "#64748b", fontSize: 13 }}>
        {selectedChild
          ? `Viewing data for ${selectedChild.student?.name}`
          : "No child selected"}
      </p>
      {/* TODO: add summary cards (attendance, fee status, recent results) */}
    </div>
  );
}
